import React, { useId } from 'react';
import { LiliTooltip, TooltipPosition } from '../LiliTooltip';

export interface LiliActionButtonProps {
  onClick?: () => void;
  ariaLabel: string;
  tooltip?: string;
  children: React.ReactNode;
}

export const LiliActionButton = React.forwardRef<HTMLButtonElement, LiliActionButtonProps>(
  ({ onClick, ariaLabel, tooltip, children }, ref) => {
    const tooltipId = useId();
    return (
      <>
        <button
          ref={ref}
          onClick={onClick}
          aria-label={ariaLabel}
          data-tooltip-id={tooltip ? tooltipId : undefined}
          className='flex items-center justify-center size-[30px] rounded-[2px] text-text-main-secondary hover:bg-surface-primary-bw-02'>
          {children}
        </button>
        {tooltip && (
          <LiliTooltip targetId={tooltipId} description={tooltip} position={TooltipPosition.TOP} />
        )}
      </>
    );
  }
);
